import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium text-sm outline-none transition-colors focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90 focus-visible:ring-destructive",
        outline:
          "border bg-background text-foreground hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        /*
         * `--success-solid` is mid-light, so its label is the dark
         * `--success-on-solid` rather than the near-white `--fg-on-accent` the
         * other solid variants use — see the on-fill rule in
         * docs/design/accessibility.md. The pairing lives here so a call site
         * cannot repaint the fill and inherit the wrong label colour.
         */
        success: "bg-success text-success-on-solid shadow-xs hover:bg-success/90",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9 rounded-md",
        touch: "h-[44px] rounded-md px-4 has-[>svg]:px-3",
        touchIcon: "size-[44px] rounded-md",
        mobileTouch: "h-9 rounded-md px-4 max-md:h-[44px] has-[>svg]:px-3",
        mobileTouchSm: "h-8 gap-1.5 rounded-md px-3 max-md:h-[44px] has-[>svg]:px-2.5",
        mobileTouchIcon: "size-9 rounded-md max-md:size-[44px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
